import type { AdoptionFormTemplate, FormField } from '../types';

// Normaliza campos de plantilla para mantener compatibilidad con UI dinámica.
export function patchTemplate(template: AdoptionFormTemplate): AdoptionFormTemplate {
  const newTemplate = JSON.parse(JSON.stringify(template));

  newTemplate.schemaJson.sections.forEach((section: any) => {
    // Inject Landline Phone field if Address exists
    const addressIndex = section.fields.findIndex((f: any) => f.id === 'address' || f.label.toLowerCase().includes('dirección') || f.label.toLowerCase().includes('direccion') || f.label.toLowerCase().includes('completa'));

    if (addressIndex !== -1) {
      const hasLandline = section.fields.some((f: any) => f.id === 'phone_landline');
      if (!hasLandline) {
        section.fields.splice(addressIndex + 1, 0, {
          id: 'phone_landline',
          type: 'tel',
          label: 'Teléfono Fijo',
          placeholder: 'Número de teléfono fijo (opcional)',
          required: false,
          binding: {
            table: 'adopter_profile',
            column: 'landline'
          }
        });
      }
    }

    section.fields.forEach((field: FormField) => {
      // 1. City/Municipality -> city type
      if (field.id === 'city' || field.label.toLowerCase().includes('municipio') || field.label.toLowerCase().includes('ciudad')) {
        field.type = 'city';
      }

      // 2. Children in house -> radio Yes/No
      if (field.id === 'has_children' || field.label.toLowerCase().includes('niños en casa')) {
        field.type = 'radio';
        field.options = [
          { value: 'true', label: 'Sí' },
          { value: 'false', label: 'No' }
        ];
      }

      // 3. Children ages -> conditional visibility
      if (field.id === 'children_ages' || field.label.toLowerCase().includes('edades')) {
        field.conditional = {
          field: 'has_children',
          operator: '==',
          value: 'true'
        };
      }

      // 4. Other pets -> radio Yes/No
      if (field.id === 'has_other_pets' || field.label.toLowerCase().includes('otras mascotas')) {
        field.type = 'radio';
        field.options = [
          { value: 'true', label: 'Sí' },
          { value: 'false', label: 'No' }
        ];
      }

      // 5. Other pets description -> conditional visibility
      if (field.id === 'other_pets_desc' || field.label.toLowerCase().includes('descripción')) {
        field.type = 'textarea';
        field.conditional = {
          field: 'has_other_pets',
          operator: '==',
          value: 'true'
        };
      }

      // 6. Preferences Lookups
      if (field.id === 'preferred_species' || field.label.toLowerCase().includes('tipo de animal')) {
        field.type = 'lookup';
        field.lookupType = 'species';
      }
      if (field.id === 'preferred_size' || field.label.toLowerCase().includes('tamaño preferido')) {
        field.type = 'lookup';
        field.lookupType = 'size';
      }
      if (field.id === 'preferred_sex' || field.label.toLowerCase().includes('sexo preferido')) {
        field.type = 'lookup';
        field.lookupType = 'sex';
      }

      // 7. Age Slider Label
      if (field.id === 'preferred_age' || field.label.toLowerCase().includes('edad aproximada')) {
        field.label = `${field.label} (meses)`;
      }

      // 8. Follow-up visits authorization -> radio Yes/No
      if (field.id === 'allows_follow_up' || field.label.toLowerCase().includes('autorizas visitas')) {
        field.type = 'radio';
        field.options = [
          { value: 'true', label: 'Sí' },
          { value: 'false', label: 'No' }
        ];
      }

      // 10. Convert all yesno type fields to radio buttons
      if (field.type === ('yesno' as any)) {
        field.type = 'radio';
        field.options = [
          { value: 'true', label: 'Sí' },
          { value: 'false', label: 'No' }
        ];
      }

      // 11. Convert visibleIf to conditional format
      const visibleIf = (field as any).visibleIf;
      if (visibleIf && visibleIf.field && visibleIf.equals !== undefined) {
        field.conditional = {
          field: visibleIf.field,
          operator: '==',
          value: String(visibleIf.equals)
        };
      }
    });
  });

  return newTemplate;
}
